import React, { createContext, useContext, useState, useEffect } from 'react';
import { EndPointGetOperatorTypes, EndPointGetOperators, EndPointDeleteOperator, EndPointCreateUpdateOperator } from '../Services/EndPointOperator';
export const UsersContext = createContext();

// Custom hook to use the Operation context
export const useUsers = () => {
  const context = useContext(UsersContext);
  if (!context) {
    throw new Error('useUsers must be used within an UsersProvider');
  }
  return context;
};

// Provider component
export const UsersProvider = ({ children }) => {
  const [miningSite, setMiningSite] = useState(0);
  const [nameFilter, setNameFilter] = useState('');
  const [idFilter, setIdFilter] = useState('');
  const [dniFilter, setDniFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState(0);
  const [openSave, setOpenSave] = useState(false);
  const [selected, setSelected] = useState(null);
  const [users, setUsers] = useState([]);
  const [deleteItem, setDeleteItem] = useState(null);
  const [operatorTypes, setOperatorTypes] = useState([]);

  const fetchOperatorTypes = async () => {
    try {
      const response = await EndPointGetOperatorTypes();
      const operatorTypesData = response.data.data || [];
      setOperatorTypes(operatorTypesData);
    } catch (error) {
      console.error('Error fetching operator types:', error);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await EndPointGetOperators(miningSite, idFilter, dniFilter, nameFilter, typeFilter);
      const ingresosData = response.data.data || [];
      setUsers(ingresosData);
      setSelected(null);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const doDelete = async () => {
    try {
      await EndPointDeleteOperator(deleteItem.operatorId, miningSite);
      setSelected(null);
      setUsers(users.filter((item) => item.operatorId !== deleteItem.operatorId));
      setDeleteItem(null);
    } catch (error) {
      console.error('Error deleting departments:', error);
    }
  };

  useEffect(() => {
    fetchOperatorTypes();
  }, []);

  useEffect(() => {
    if (miningSite === 0) {
      setUsers([]);
      return;
    }

    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [miningSite, nameFilter, idFilter, typeFilter]);


  const doSave = async (form) => {
    try {
      console.log({ form });
      const response = await EndPointCreateUpdateOperator({...form, miningSiteId: miningSite, id: form.id || null });

      if (!response.data.success){
        return;
      }
      fetchUsers();
      setOpenSave(true); 
    } catch (error) {
      console.error('Error saving department:', error);
    }
  }

  const contextValue = {
    miningSite,
    nameFilter,
    idFilter,
    dniFilter,
    typeFilter,
    selected,
    users,
    deleteItem,
    openSave,
    operatorTypes,

    setOpenSave,
    setMiningSite,
    setNameFilter,
    setIdFilter,
    setDniFilter,
    setTypeFilter,
    setSelected,
    setDeleteItem,
    setUsers,

    doSave,
    doDelete,
  };

  return (
    <UsersContext.Provider value={contextValue}>
      {children}
    </UsersContext.Provider>
  );
}